import { render, staticRenderFns } from "./CollectionActionPostpone.vue?vue&type=template&id=7d87bed4&scoped=true&"
import script from "./CollectionActionPostpone.vue?vue&type=script&lang=ts&"
export * from "./CollectionActionPostpone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d87bed4",
  null
  
)

export default component.exports